import $ from "jquery";

/**
 * Search form
 *
 * De twee dropdownknoppen tonen in rust de naam van het filter ("Alle reissoorten", "Alle
 * reisduren") en daarna de aangevinkte waarden.
 */

const BUTTONS = [
	{
		checkbox: "input[name='template-kinds[]']",
		button: ".sb_search-form_template-kinds_button",
	},
	{
		checkbox: "input[name='days-ranges[]']",
		button: ".sb_search-form_trip-duration_button",
	},
];

/**
 * Store original button text per instance on load
 */
$(function () {
	BUTTONS.forEach(({ button }) => {
		$(button).each(function () {
			const $btn = $(this);
			$btn.data("original-text", $btn.text().trim());
		});
	});
});

/**
 * Dropdown direction - open below the button, and only above when the pane doesn't fit below but
 * does fit above. Same rule as select2 uses for the destinations (see `select2.js`), so all three
 * fields in the sticky bar open the same way.
 *
 * The panes have `data-allow-overlap="true"`, so Foundation keeps whatever position it is given
 * instead of cycling through left/right; the direction is picked here, right after Foundation has
 * positioned the pane and before the browser paints.
 *
 * The measurement is select2's own (`AttachBody._positionDropdown`): anchor edge plus dropdown
 * height, without the gap in between. Both dropdowns share the height and the gap
 * (`search-form.scss`), so they flip at exactly the same scroll position.
 */
$(".sb_search-form").on("show.zf.dropdown", ".dropdown-pane", function () {
	const plugin = $(this).data("zfPlugin");

	if (!plugin || !plugin.$currentAnchor) {
		return;
	}

	const anchor = plugin.$currentAnchor[0].getBoundingClientRect();
	const height = $(this).outerHeight();
	const fitsBelow = anchor.bottom + height < window.innerHeight;
	const fitsAbove = anchor.top - height > 0;
	const position = !fitsBelow && fitsAbove ? "top" : "bottom";

	if (plugin.position !== position) {
		plugin.position = position;
		// Foundation binds its own `_setPosition` to this event
		$(this).trigger("resizeme.zf.trigger");
	}
});

/**
 * On checkbox change -> update the button text for that form only
 */
BUTTONS.forEach(({ checkbox, button }) => {
	$(".sb_search-form").on("change", checkbox, function () {
		const $form = $(this).closest(".sb_search-form");

		const selectedLabels = $form
			.find(`${checkbox}:checked`)
			.map(function () {
				return $(this).next("label").text().trim();
			})
			.get();

		const $btn = $form.find(button);

		if (selectedLabels.length > 0) {
			$btn.text(selectedLabels.join(", "));
		} else {
			$btn.text($btn.data("original-text"));
		}
	});
});
